import React from "react";

const Header = () => {
  return (
    <header className="bg-violeta p-relative">
      <div className="container pt-8 pl-5">
        <div className="row row-cols-1 row-cols-lg-2">
          <div className="col">
            <div className="d-flex gap-28">
              <img src="./img/world-cup.svg" alt="Copa Qatar 2022" />
              <img src="./img/vector-header.svg" alt="vector header" />
              <img src="./img/kia-logo-blanco.svg" alt="Logo kia" />
            </div>
            <div className="header-text">
              <p className="white header">
                Kia Argentina te lleva <br />
                <div
                  style={{ position: "relative" }}
                  style={{ display: "inline-block" }}
                >
                  {" "}
                  <div>
                    a la Copa Mundial de la{" "}
                    <div style={{ display: "inline-block" }}>
                      FIFA
                      <sup
                        style={{
                          verticalAlign: "75%",
                          lineHeight: "5px",
                          fontSize: "8px",
                          top: "-2.5em",
                        }}
                      >
                        TM
                      </sup>
                    </div>
                  </div>
                </div>
              </p>
              <p className="fw300 rti">#RoadToInspiration</p>
            </div>
          </div>

          <div className="col">
            <img
              src="./img/frame-header.png"
              alt="Frame-header"
              className="ocultar-mobile"
              style={{ maxWidth: "100%", paddingBottom: "20px" }}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
